module.exports = __webpack_public_path__ + "docs/funds-33e45b.md";